var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backlink"},[_c('b-button',{staticClass:"mb-2",attrs:{"variant":"light"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"far fa-angle-left fa-lg"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-471b24a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/BackLink.vue
// module id = 1282
// module chunks = 0